/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkActiveUserCountResponseDto } from '../models/work-active-user-count-response-dto';
import { WorkCreateExternalDocumentLinkDto } from '../models/work-create-external-document-link-dto';
import { WorkCreateExternalProjectLinkDto } from '../models/work-create-external-project-link-dto';
import { WorkCreateExternalTaskLinkDto } from '../models/work-create-external-task-link-dto';
import { WorkDocument } from '../models/work-document';
import { WorkProject } from '../models/work-project';
import { WorkRevertTaskFieldDto } from '../models/work-revert-task-field-dto';
import { WorkTenantDocumentLink } from '../models/work-tenant-document-link';
import { WorkTenantProjectLink } from '../models/work-tenant-project-link';
import { WorkTenantTaskChangelog } from '../models/work-tenant-task-changelog';
import { WorkTenantTaskLink } from '../models/work-tenant-task-link';
import { WorkUpdateChangelogStatusDto } from '../models/work-update-changelog-status-dto';
import { WorkUpdateDocumentV2Dto } from '../models/work-update-document-v-2-dto';
import { WorkUpdateProjectLinkNumberDto } from '../models/work-update-project-link-number-dto';

@Injectable({ providedIn: 'root' })
export class WorkTenantsToTenantsV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantToTenantV2ControllerGetProjectsByTeamRoletype()` */
  static readonly TenantToTenantV2ControllerGetProjectsByTeamRoletypePath = '/v2/tenants/tenant-to-tenant/projects-by-team-roletype';

  /**
   * Get projects filtered by team roletype (generic, for external tenants).
   *
   * Returns projects that have tasks assigned to teams with the specified roletypeName. Optionally calculates a price summary based on specified calculationItemIds.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetProjectsByTeamRoletype()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectsByTeamRoletype$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      fromDate: string;
      toDate: string;
      roletypeName: string;
      calculationItemIds: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetProjectsByTeamRoletypePath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.query('fromDate', params.fromDate, {});
      rb.query('toDate', params.toDate, {});
      rb.query('roletypeName', params.roletypeName, {});
      rb.query('calculationItemIds', params.calculationItemIds, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * Get projects filtered by team roletype (generic, for external tenants).
   *
   * Returns projects that have tasks assigned to teams with the specified roletypeName. Optionally calculates a price summary based on specified calculationItemIds.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetProjectsByTeamRoletype$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectsByTeamRoletype(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      fromDate: string;
      toDate: string;
      roletypeName: string;
      calculationItemIds: string;
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.tenantToTenantV2ControllerGetProjectsByTeamRoletype$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetProjectCustomerName()` */
  static readonly TenantToTenantV2ControllerGetProjectCustomerNamePath = '/v2/tenants/tenant-to-tenant/projects/{id}/customer-name';

  /**
   * Get customer name of a project (for tenant-to-tenant display).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetProjectCustomerName()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectCustomerName$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetProjectCustomerNamePath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Get customer name of a project (for tenant-to-tenant display).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetProjectCustomerName$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectCustomerName(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerGetProjectCustomerName$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetProject()` */
  static readonly TenantToTenantV2ControllerGetProjectPath = '/v2/tenants/tenant-to-tenant/projects/{id}';

  /**
   * Get project data (for external tenants).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProject$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetProjectPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Get project data (for external tenants).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProject(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.tenantToTenantV2ControllerGetProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetAllTenants()` */
  static readonly TenantToTenantV2ControllerGetAllTenantsPath = '/v2/tenants/tenant-to-tenant/tenants';

  /**
   * Get all tenants (for tenant-ID mapping).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetAllTenants()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetAllTenants$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetAllTenantsPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * Get all tenants (for tenant-ID mapping).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetAllTenants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetAllTenants(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.tenantToTenantV2ControllerGetAllTenants$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetProjectLinksForProject()` */
  static readonly TenantToTenantV2ControllerGetProjectLinksForProjectPath = '/v2/tenants/tenant-to-tenant/project-links/project/{projectId}';

  /**
   * Get project links for a project (for sync).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetProjectLinksForProject()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectLinksForProject$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantProjectLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetProjectLinksForProjectPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantProjectLink>>;
      })
    );
  }

  /**
   * Get project links for a project (for sync).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetProjectLinksForProject$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectLinksForProject(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantProjectLink>> {
    return this.tenantToTenantV2ControllerGetProjectLinksForProject$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantProjectLink>>): Array<WorkTenantProjectLink> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerFindProjectsByNumber()` */
  static readonly TenantToTenantV2ControllerFindProjectsByNumberPath = '/v2/tenants/tenant-to-tenant/projects';

  /**
   * Find project by numberQualified.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerFindProjectsByNumber()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerFindProjectsByNumber$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      numberQualified: string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkProject>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerFindProjectsByNumberPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.query('numberQualified', params.numberQualified, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkProject>>;
      })
    );
  }

  /**
   * Find project by numberQualified.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerFindProjectsByNumber$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerFindProjectsByNumber(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      numberQualified: string;
    },
    context?: HttpContext
  ): Observable<Array<WorkProject>> {
    return this.tenantToTenantV2ControllerFindProjectsByNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkProject>>): Array<WorkProject> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetProjectTasks()` */
  static readonly TenantToTenantV2ControllerGetProjectTasksPath = '/v2/tenants/tenant-to-tenant/projects/{id}/tasks';

  /**
   * Get tasks of a project (for external tenants).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetProjectTasks()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectTasks$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetProjectTasksPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Get tasks of a project (for external tenants).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetProjectTasks$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectTasks(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.tenantToTenantV2ControllerGetProjectTasks$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetTask()` */
  static readonly TenantToTenantV2ControllerGetTaskPath = '/v2/tenants/tenant-to-tenant/tasks/{id}';

  /**
   * Get task details (for external tenants).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetTask$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetTaskPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Get task details (for external tenants).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetTask(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.tenantToTenantV2ControllerGetTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetTaskLinksForProjectLink()` */
  static readonly TenantToTenantV2ControllerGetTaskLinksForProjectLinkPath = '/v2/tenants/tenant-to-tenant/task-links/project-link/{projectLinkId}';

  /**
   * Get task links for a project link (for tenant-to-tenant sync).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetTaskLinksForProjectLink()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetTaskLinksForProjectLink$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantTaskLink>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetTaskLinksForProjectLinkPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('projectLinkId', params.projectLinkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantTaskLink>>;
      })
    );
  }

  /**
   * Get task links for a project link (for tenant-to-tenant sync).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetTaskLinksForProjectLink$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetTaskLinksForProjectLink(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantTaskLink>> {
    return this.tenantToTenantV2ControllerGetTaskLinksForProjectLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantTaskLink>>): Array<WorkTenantTaskLink> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerCreateTaskLinkFromExternal()` */
  static readonly TenantToTenantV2ControllerCreateTaskLinkFromExternalPath = '/v2/tenants/tenant-to-tenant/task-links';

  /**
   * Create task link from external tenant (bidirectional).
   *
   * Allows an external tenant to notify about a task link creation. Creates a mirrored link locally.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerCreateTaskLinkFromExternal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerCreateTaskLinkFromExternal$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkCreateExternalTaskLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantTaskLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerCreateTaskLinkFromExternalPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantTaskLink>;
      })
    );
  }

  /**
   * Create task link from external tenant (bidirectional).
   *
   * Allows an external tenant to notify about a task link creation. Creates a mirrored link locally.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerCreateTaskLinkFromExternal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerCreateTaskLinkFromExternal(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkCreateExternalTaskLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantTaskLink> {
    return this.tenantToTenantV2ControllerCreateTaskLinkFromExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantTaskLink>): WorkTenantTaskLink => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerDeleteTaskLinkFromExternal()` */
  static readonly TenantToTenantV2ControllerDeleteTaskLinkFromExternalPath = '/v2/tenants/tenant-to-tenant/task-links';

  /**
   * Delete task link from external tenant (sync).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerDeleteTaskLinkFromExternal()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDeleteTaskLinkFromExternal$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      localTaskId: number;
      externalTaskId: number;
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerDeleteTaskLinkFromExternalPath, 'delete');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.query('localTaskId', params.localTaskId, {});
      rb.query('externalTaskId', params.externalTaskId, {});
      rb.query('projectLinkId', params.projectLinkId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete task link from external tenant (sync).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerDeleteTaskLinkFromExternal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDeleteTaskLinkFromExternal(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      localTaskId: number;
      externalTaskId: number;
      projectLinkId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerDeleteTaskLinkFromExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerCreateProjectLinkFromExternal()` */
  static readonly TenantToTenantV2ControllerCreateProjectLinkFromExternalPath = '/v2/tenants/tenant-to-tenant/project-links';

  /**
   * Create project link from external tenant (bidirectional).
   *
   * Allows an external tenant to notify about a project link creation. Creates a mirrored link locally.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerCreateProjectLinkFromExternal()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerCreateProjectLinkFromExternal$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkCreateExternalProjectLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantProjectLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerCreateProjectLinkFromExternalPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantProjectLink>;
      })
    );
  }

  /**
   * Create project link from external tenant (bidirectional).
   *
   * Allows an external tenant to notify about a project link creation. Creates a mirrored link locally.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerCreateProjectLinkFromExternal$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerCreateProjectLinkFromExternal(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkCreateExternalProjectLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantProjectLink> {
    return this.tenantToTenantV2ControllerCreateProjectLinkFromExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantProjectLink>): WorkTenantProjectLink => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerDeleteProjectLinkFromExternal()` */
  static readonly TenantToTenantV2ControllerDeleteProjectLinkFromExternalPath = '/v2/tenants/tenant-to-tenant/project-links';

  /**
   * Delete project link from external tenant (sync).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerDeleteProjectLinkFromExternal()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDeleteProjectLinkFromExternal$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      localProjectId: number;
      externalProjectId: number;
      tenantId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerDeleteProjectLinkFromExternalPath, 'delete');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.query('localProjectId', params.localProjectId, {});
      rb.query('externalProjectId', params.externalProjectId, {});
      rb.query('tenantId', params.tenantId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete project link from external tenant (sync).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerDeleteProjectLinkFromExternal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDeleteProjectLinkFromExternal(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      localProjectId: number;
      externalProjectId: number;
      tenantId: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerDeleteProjectLinkFromExternal$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerUpdateProjectLinkNumber()` */
  static readonly TenantToTenantV2ControllerUpdateProjectLinkNumberPath = '/v2/tenants/tenant-to-tenant/project-links/update-number';

  /**
   * Update external project number of existing project link (sync).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerUpdateProjectLinkNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerUpdateProjectLinkNumber$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkUpdateProjectLinkNumberDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerUpdateProjectLinkNumberPath, 'patch');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Update external project number of existing project link (sync).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerUpdateProjectLinkNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerUpdateProjectLinkNumber(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkUpdateProjectLinkNumberDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerUpdateProjectLinkNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetChangelogsForTask()` */
  static readonly TenantToTenantV2ControllerGetChangelogsForTaskPath = '/v2/tenants/tenant-to-tenant/changelogs/task/{taskId}';

  /**
   * Get changelogs for a task (from external tenant).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetChangelogsForTask()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetChangelogsForTask$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      taskId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<{
}>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetChangelogsForTaskPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('taskId', params.taskId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<{
        }>>;
      })
    );
  }

  /**
   * Get changelogs for a task (from external tenant).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetChangelogsForTask$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetChangelogsForTask(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      taskId: number;
    },
    context?: HttpContext
  ): Observable<Array<{
}>> {
    return this.tenantToTenantV2ControllerGetChangelogsForTask$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<{
}>>): Array<{
}> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerUpdateChangelogStatus()` */
  static readonly TenantToTenantV2ControllerUpdateChangelogStatusPath = '/v2/tenants/tenant-to-tenant/changelogs/{id}/status';

  /**
   * Update changelog status from external tenant (sync).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerUpdateChangelogStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerUpdateChangelogStatus$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
      body: WorkUpdateChangelogStatusDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantTaskChangelog>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerUpdateChangelogStatusPath, 'patch');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantTaskChangelog>;
      })
    );
  }

  /**
   * Update changelog status from external tenant (sync).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerUpdateChangelogStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerUpdateChangelogStatus(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
      body: WorkUpdateChangelogStatusDto
    },
    context?: HttpContext
  ): Observable<WorkTenantTaskChangelog> {
    return this.tenantToTenantV2ControllerUpdateChangelogStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantTaskChangelog>): WorkTenantTaskChangelog => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerRevertTaskField()` */
  static readonly TenantToTenantV2ControllerRevertTaskFieldPath = '/v2/tenants/tenant-to-tenant/tasks/{taskId}/revert-field';

  /**
   * Revert a task field to a value sent by the rejecting external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerRevertTaskField()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerRevertTaskField$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      taskId: number;
      body: WorkRevertTaskFieldDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerRevertTaskFieldPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('taskId', params.taskId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Revert a task field to a value sent by the rejecting external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerRevertTaskField$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerRevertTaskField(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      taskId: number;
      body: WorkRevertTaskFieldDto
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerRevertTaskField$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerCreateDocumentLink()` */
  static readonly TenantToTenantV2ControllerCreateDocumentLinkPath = '/v2/tenants/tenant-to-tenant/document-links';

  /**
   * Create document link from external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerCreateDocumentLink()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerCreateDocumentLink$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkCreateExternalDocumentLinkDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantDocumentLink>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerCreateDocumentLinkPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantDocumentLink>;
      })
    );
  }

  /**
   * Create document link from external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerCreateDocumentLink$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerCreateDocumentLink(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      body: WorkCreateExternalDocumentLinkDto
    },
    context?: HttpContext
  ): Observable<WorkTenantDocumentLink> {
    return this.tenantToTenantV2ControllerCreateDocumentLink$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantDocumentLink>): WorkTenantDocumentLink => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetDocument()` */
  static readonly TenantToTenantV2ControllerGetDocumentPath = '/v2/tenants/tenant-to-tenant/documents/{id}';

  /**
   * Get document data for external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetDocument$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetDocumentPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Get document data for external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetDocument(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.tenantToTenantV2ControllerGetDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerDeleteDocument()` */
  static readonly TenantToTenantV2ControllerDeleteDocumentPath = '/v2/tenants/tenant-to-tenant/documents/{id}';

  /**
   * Delete document from external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerDeleteDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDeleteDocument$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerDeleteDocumentPath, 'delete');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Delete document from external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerDeleteDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDeleteDocument(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerDeleteDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerUpdateDocument()` */
  static readonly TenantToTenantV2ControllerUpdateDocumentPath = '/v2/tenants/tenant-to-tenant/documents/{id}';

  /**
   * Update document from external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerUpdateDocument()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerUpdateDocument$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
      body: WorkUpdateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerUpdateDocumentPath, 'patch');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Update document from external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerUpdateDocument$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantToTenantV2ControllerUpdateDocument(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
      body: WorkUpdateDocumentV2Dto
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.tenantToTenantV2ControllerUpdateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerGetProjectDocuments()` */
  static readonly TenantToTenantV2ControllerGetProjectDocumentsPath = '/v2/tenants/tenant-to-tenant/projects/{projectId}/documents';

  /**
   * Get documents for a project (from external tenant).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerGetProjectDocuments()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectDocuments$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      projectId: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDocument>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerGetProjectDocumentsPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('projectId', params.projectId, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDocument>>;
      })
    );
  }

  /**
   * Get documents for a project (from external tenant).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerGetProjectDocuments$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerGetProjectDocuments(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      projectId: number;
    },
    context?: HttpContext
  ): Observable<Array<WorkDocument>> {
    return this.tenantToTenantV2ControllerGetProjectDocuments$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDocument>>): Array<WorkDocument> => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerCreateDocument()` */
  static readonly TenantToTenantV2ControllerCreateDocumentPath = '/v2/tenants/tenant-to-tenant/documents';

  /**
   * Create document from external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerCreateDocument()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerCreateDocument$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkDocument>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerCreateDocumentPath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkDocument>;
      })
    );
  }

  /**
   * Create document from external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerCreateDocument$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerCreateDocument(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<WorkDocument> {
    return this.tenantToTenantV2ControllerCreateDocument$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkDocument>): WorkDocument => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerDownloadDocumentFile()` */
  static readonly TenantToTenantV2ControllerDownloadDocumentFilePath = '/v2/tenants/tenant-to-tenant/documents/{id}/file';

  /**
   * Download document file for external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerDownloadDocumentFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDownloadDocumentFile$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<{
}>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerDownloadDocumentFilePath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<{
        }>;
      })
    );
  }

  /**
   * Download document file for external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerDownloadDocumentFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerDownloadDocumentFile(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<{
}> {
    return this.tenantToTenantV2ControllerDownloadDocumentFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
}>): {
} => r.body)
    );
  }

  /** Path part for operation `tenantToTenantV2ControllerUploadDocumentFile()` */
  static readonly TenantToTenantV2ControllerUploadDocumentFilePath = '/v2/tenants/tenant-to-tenant/documents/{id}/file';

  /**
   * Upload document file from external tenant.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantV2ControllerUploadDocumentFile()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerUploadDocumentFile$Response(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantV2ControllerUploadDocumentFilePath, 'post');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Upload document file from external tenant.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantV2ControllerUploadDocumentFile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantV2ControllerUploadDocumentFile(
    params: {

    /**
     * Tenant API Key for authentication
     */
      'X-API-Key': string;
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantToTenantV2ControllerUploadDocumentFile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantToTenantUsersV2ControllerGetActiveUserCount()` */
  static readonly TenantToTenantUsersV2ControllerGetActiveUserCountPath = '/v2/tenants/tenant-to-tenant/users/active-count';

  /**
   * Anzahl aktiver Mitarbeitender (users.active = 1).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantToTenantUsersV2ControllerGetActiveUserCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantUsersV2ControllerGetActiveUserCount$Response(
    params: {

    /**
     * worksuite-admin Shared-Key (WORKSUITE_ADMIN_SHARED_KEY)
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkActiveUserCountResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsToTenantsV2Service.TenantToTenantUsersV2ControllerGetActiveUserCountPath, 'get');
    if (params) {
      rb.header('X-API-Key', params['X-API-Key'], {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkActiveUserCountResponseDto>;
      })
    );
  }

  /**
   * Anzahl aktiver Mitarbeitender (users.active = 1).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantToTenantUsersV2ControllerGetActiveUserCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantToTenantUsersV2ControllerGetActiveUserCount(
    params: {

    /**
     * worksuite-admin Shared-Key (WORKSUITE_ADMIN_SHARED_KEY)
     */
      'X-API-Key': string;
    },
    context?: HttpContext
  ): Observable<WorkActiveUserCountResponseDto> {
    return this.tenantToTenantUsersV2ControllerGetActiveUserCount$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkActiveUserCountResponseDto>): WorkActiveUserCountResponseDto => r.body)
    );
  }

}
